import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Title = styled.span`
  font-size: ${theme.typography.sizes.sm};
  color: ${theme.colors.neutral.black};
  font-weight: ${theme.typography.weight.md};
`

export const Container = styled.div`
  background-color: ${theme.colors.neutral.white};
  padding: ${theme.spacing.xm};
  border-radius: ${theme.shapes.borderRadius.xm};
  border: 1px solid ${theme.colors.neutral.softer};
`

export const TitleBar = styled.div`
  display: flex;
  align-items: center;
  padding: ${theme.spacing.xm};
  background-color: ${theme.colors.neutral.white};
  gap: ${theme.spacing.xs};
`

export const TableWrapper = styled.div`
  display: grid;
  width: 100%;
  overflow-x: auto;
  gap: ${theme.spacing.xm};
`

export const ReprocessBatchContainer = styled.div<{ visible: boolean }>`
  ${({ visible }) => (visible ? 'display: flex' : 'display: none')};
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: ${theme.spacing.ion.large};
  border-radius: ${theme.shapes.borderRadius.xm};
  border: 1px solid ${theme.colors.ion.neutral.softer};
`

export const ErrorBox = styled.div`
  background-color: ${theme.colors.ion.neutral.alwayswhite};
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.ion.small};
  width: 100%;
  padding: ${theme.spacing.ion.small};
  border-radius: 4px;
`
